import styled from "styled-components";

export const Container = styled.div`
  position: relative;
  
  header {
    width: 100%;
    height: 80px;
    background: #ffffff;
    margin-bottom: 5px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-shadow: 0px 3px 3px rgba(0, 0, 0, 0.1);

    div.header-logo-box {
      display: flex;
      align-items: flex-end;
      flex-direction: column;
      flex: 1;
      min-width: 110px;
      min-height: auto;

      img.viveo {
        max-width: 116px;
        max-height: 27px;
      }
    }

    div.header-input-search-box {      
      input {
        width: 100%;
        padding-left: 12px;

        &::placeholder {
          color: rgba(103, 103, 103, 0.8);
        }
      }
    }

    div.header-selected-company-box {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 0.5em 0 0.5em;
      width: auto;
      height: 40px;
      background: #f2f2f2;
      border-radius: 5px;

      h3 {
        color: #625c5c;
        font-style: normal;
        font-weight: 500;
        font-size: 15px;
        line-height: 18px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        width: 90%;
        padding-right: 10px;
        margin-right: 10px;
      }
    }

    div.header-menu-items-box {
      display: flex;
      justify-content: space-between;
      align-items: center;
      max-width: 500px;
      margin: 0 20px 0;

      p {
        font-style: normal;
        font-weight: 500;
        font-size: 15px;
        line-height: 18px;
      }
    }

    @media only screen and (max-width: 1243px) {
      div.header-menu-items-box {
        margin: 0 3px 0;
      }
    }

    @media only screen and (max-width: 1300px) {
      .hide-menu, .hide-button {
        display: none;
      }
    }

    @media only screen and (max-width: 768px) {
      margin-bottom: 0;
    }

    div.header-user-info-box {
      display: flex;
      align-items: center;
      max-width: 220px;

      div.header-user-img-box {
        border-radius: 50%;
        width: 40px;
        height: 40px;
        min-width: 40px;
        min-height: 40px;
        background: #e5e5e5;

        img {
          border-radius: 50%;
          width: 100%;
          height: 100%;
        }
      }
    }
  }
`;
